/**
 * Pipes that format dates and numbers in the browser's regional locale.
 *
 * Drop-in replacements for Angular's `date:'short'` and `number`, which are
 * pinned to `en-US` in this app because no locale data is registered.
 * See `utils/locale.utils.ts` for why the browser locale drives formatting
 * rather than the in-app language picker.
 *
 * Both pipes are pure: the browser locale does not change while the app runs.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { formatDateTime, formatNumber } from '../utils/locale.utils';

@Pipe({ name: 'localDateTime' })
export class LocalDateTimePipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined): string {
    return formatDateTime(value);
  }
}

@Pipe({ name: 'localNumber' })
export class LocalNumberPipe implements PipeTransform {
  transform(value: number | null | undefined, digitsInfo: string): string {
    return formatNumber(value, digitsInfo);
  }
}
